import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { addStep, clearStep, popStep } from '../actions/Breadcrumbs';
import { epikBoxesCompanyFilter } from '../actions/EpikBoxes';
import { masterBoxPressCall } from '../actions/Users';

const Breadcrumbss = ({
  clearStep,
  addStep,
  epikBoxesCompanyFilter,
  popStep,
  masterBoxPress,
  masterBoxPressCall,
  boxName,
  steps,
}) => {
  const [localSteps, setLocalSteps] = useState([]);

  const handleNaviagtion = (label, e) => {
    global.backStatus = true;
    if (global.backStatus) {
      if (e === '/boxes') {
        global.boxDetailStatus = false;
        epikBoxesCompanyFilter({});
      } else if (e !== 'goBack') {
        window.history.back();
      }
      if (e === 'goBack') {
        if (masterBoxPress) {
          window.history.go(-2);
          masterBoxPressCall(false);
        } else {
          window.history.back();
        }
      }
      clearStep(label);
      addStep({ label, redirect: e });
    }
  };

  useEffect(() => {
    setLocalSteps(JSON.parse(localStorage.getItem('steps')));
  }, [steps]);

  return (
    <div className="breadcrumb">
      {localSteps &&
        localSteps.length &&
        localSteps.map((item, idx) => {
          return idx === localSteps.length - 1 ? (
            <a
              className={
                idx === localSteps.length - 1 ? 'active breadcrumb-item' : 'breadcrumb-item'
              }
              key={idx}
            >
              {item.label}
            </a>
          ) : item.redirect === '/boxes' || item.redirect === '/' ? (
            <Link
              onClick={() => {
                if (item.redirect === '/') {
                  console.log('cool');
                } else {
                  handleNaviagtion(item.label, item.redirect);
                }
              }}
              to={item.redirect}
              className={
                idx === localSteps.length - 1 ? 'active breadcrumb-item' : 'breadcrumb-item'
              }
              key={idx}
            >
              {item.label}
            </Link>
          ) : (
            <a
              onClick={() => handleNaviagtion(item.label, item.redirect)}
              className={
                idx === localSteps.length - 1
                  ? 'active breadcrumb-item'
                  : 'breadcrumb-item breadcrumb-underline'
              }
              key={idx}
            >
              {item.label}
            </a>
          );
        })}
    </div>
  );
};

const mapStateToProps = state => ({
  steps: state.UIState.steps,
  masterBoxPress: state.UIState.users.masterBoxPress,
});

const mapDispatchToProps = dispatch => ({
  addStep: step => dispatch(addStep(step)),
  clearStep: step => dispatch(clearStep(step)),
  popStep: () => dispatch(popStep()),
  epikBoxesCompanyFilter: filter => dispatch(epikBoxesCompanyFilter(filter)),
  masterBoxPressCall: status => dispatch(masterBoxPressCall(status)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Breadcrumbss);
